<template>
  <a-modal
    :maskClosable="false"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    @cancel="handleCancel"
    :footer="null"
    :zIndex="999"
  >
    <div class="course-header">
      <span :class="{ 'item-active': tabIndex == '1' }" @click="tabIndex = 1"
        >课程详情</span
      >
      <span :class="{ 'item-active': tabIndex == '2' }" @click="tabIndex = 2"
        >审核详情</span
      >
    </div>
    <!-- 课程详情 -->
    <div v-show="tabIndex == 1">
      <ul class="course-info">
        <!-- 站点只有平台管理员才有 -->
        <li v-if="userInfo && userInfo.accRole.id == '6'">
          <span class="key">站点：</span>
          <span class="value">{{ course.bureauName }}</span>
        </li>
        <li>
          <span class="key">封面图：</span>
          <span class="value"
            ><img :src="course.coverUrl || './courseIcon.png'"
          /></span>
        </li>
        <li>
          <span class="key">课程名字：</span>
          <span class="value">{{ course.courseName }}</span>
        </li>
        <li>
          <span class="key">适用年级：</span>
          <span class="value">{{ course.gradeScope | gradeScopeFilter }}</span>
        </li>
        <li>
          <span class="key">开班最低人数：</span>
          <span class="value">{{ course.lowerLimit }}</span>
        </li>
        <li>
          <span class="key">开班最高人数：</span>
          <span class="value">{{ course.upperLimit }}</span>
        </li>
        <li>
          <span class="key">场地备注：</span>
          <span class="value">{{ course.placeRemark }}</span>
        </li>
        <li>
          <span class="key">课程梯度：</span>
          <span class="value">{{ course.tagGradientName }}</span>
        </li>
        <li>
          <span class="key">课程周期：</span>
          <span class="value">{{ course.tagCycleName }}</span>
        </li>
        <li>
          <span class="key">上课周期：</span>
          <span class="value">{{ course.classWeeks | weekName }}</span>
        </li>
        <li>
          <span class="key">建议教学时长范围：</span>
          <span class="value">{{ course.teachingTime }}分钟</span>
        </li>
        <li>
          <span class="key">课程级别：</span>
          <span class="value">{{ course.courseLevel | courseLevel }}</span>
        </li>
        <li>
          <span class="key">课时数：</span>
          <span class="value">{{ course.classHours }}</span>
        </li>
        <li>
          <span class="key"><span v-if="roleId == 4">家长报名</span>课时总价/元：</span>
          <span class="value">{{ course.coursePrice / 100 }}</span>
        </li>
        <li v-if="institutionSetting.institutionCourseBureauPurchase == '1' && (roleId == 4 || roleId == 6)">
          <span class="key">教育局采购采购价/元：</span>
          <span class="value">{{ course.purchasePrice / 100 || 0 }}</span>
        </li>
        <li v-if="institutionSetting.institutionCourseBureauPurchase == '1' && (roleId == 4 || roleId == 6)">
          <span class="key">采购价格说明：</span>
          <span class="value">{{ course.purchaseComment }}</span>
        </li>
        <li>
          <span class="key">是否包含教材/教具：</span>
          <span class="value">{{
            course.hasTextbook == '1' ? '是' : '否'
          }}</span>
        </li>
        <li>
          <span class="key">教材/教具名称：</span>
          <span class="value">{{ course.textbook }}</span>
        </li>
        <li>
          <span class="key">教材/教具价格/元：</span>
          <span class="value">{{ course.textbookPrice / 100 }}</span>
        </li>
        <li>
          <span class="key">是否必须购买：</span>
          <span class="value">{{
            course.textbookRequired == '1' ? '是' : '否'
          }}</span>
        </li>
        <li>
          <span class="key">总价格/元：</span>
          <span class="value">{{ course.totalPrice / 100 ===-0.01 ?0:course.totalPrice / 100 }}</span>
        </li>
        <li>
          <span class="key">课程分类：</span>
          <span class="value">{{ course.classifyId | classifyFilter }}</span>
        </li>
        <li>
          <span class="key">课程类目：</span>
          <span class="value"
            >{{ course.cateFirstId | cateFilter }}-{{
              course.cateSecondId | cateFilter
            }}-{{ course.cateThirdId | cateFilter }}</span
          >
        </li>
        <li>
          <span class="key">课程来源：</span>
          <span class="value">{{ course.sourceTypeText }}</span>
        </li>
        <li v-if="course.sourceType == 2">
          <span class="key">课程方种类：</span>
          <span class="value">{{ course.institutionTypeName }}</span>
        </li>
        <li v-if="course.institutionName">
          <span class="key">课程方名称：</span>
          <span class="value">{{ course.institutionName }}</span>
        </li>
        <li v-if="course.schoolName">
          <span class="key">学校名称：</span>
          <span class="value">{{ course.schoolName }}</span>
        </li>
        <li
          v-if="
            course.serviceSchoolNameList &&
            course.serviceSchoolNameList.length > 0
          "
        >
          <span class="key">服务学校：</span>
          <span class="value">{{
            course.serviceSchoolNameList
              ? course.serviceSchoolNameList.join(',')
              : ''
          }}</span>
        </li>
        <!-- <li v-if="course.providerNameList">
          <span class="key">提供方：</span>
          <span class="value">{{ course.providerNameList.join(',') }}</span>
        </li> -->
        <li>
          <span class="key">审核状态：</span>
          <span class="value">{{ course.statusText }}</span>
        </li>
        <li v-if="course.status == '2'">
          <span class="key">不通过理由：</span>
          <span class="value">{{ course.failReason }}</span>
        </li>
        <li>
          <span class="key">课节内容：</span>
          <div class="value">
            <div
              class="item"
              v-for="(item, index) in course.courseLesson"
              :key="index"
            >
              <div>课节标题：{{ item.title }}</div>
              <div>课节内容：{{ item.content }}</div>
              <div>
                课节资源：
                <div class="file-list">
                  <template v-if="item.lessonResource">
                    <div>1.授课课件：</div>
                    <div
                      v-for="fileInfo in item.lessonResource.filter(
                        (item) => item.lesType == '1'
                      )"
                      :key="fileInfo.id"
                    >
                      {{ fileInfo.fileName }}
                    </div>
                  </template>
                  <template v-if="item.lessonResource">
                    <div>2.课程视频片段：</div>
                    <div
                      v-for="fileInfo in item.lessonResource.filter(
                        (item) => item.lesType == '2'
                      )"
                      :key="fileInfo.id"
                    >
                      {{ fileInfo.fileName }}
                    </div>
                  </template>
                  <template v-if="item.lessonResource">
                    <div>3.教学教案：</div>
                    <div
                      v-for="fileInfo in item.lessonResource.filter(
                        (item) => item.lesType == '3'
                      )"
                      :key="fileInfo.id"
                    >
                      {{ fileInfo.fileName }}
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li v-if="course.intro">
          <span class="key">课程介绍：</span>
          <span class="intro" v-html="course.intro"></span>
        </li>
      </ul>

      <!-- 只有教育局和代理能够审核，并且只能审核课程方的课 -->
      <div
        class="course-check"
        v-if="
          userInfo &&
          (userInfo.accRole.id == '2' || userInfo.accRole.id == '1') &&
          course.sourceType == '2' &&
          course.status == '0'
        "
      >
        <a-button
          type="primary"
          @click="checkCourse('1')"
          style="margin-right: 20px"
          >审核通过</a-button
        >
        <a-button type="primary" @click="isNoPass = true">审核不通过</a-button>
        <div v-if="isNoPass" class="check-confirm">
          <a-textarea
            placeholder="请输入审核不通过理由"
            :autosize="{ minRows: 2, maxRows: 6 }"
            v-model="failReason"
          />
          <a-button type="primary" @click="checkCourse('2')">确定</a-button>
        </div>
      </div>
    </div>

    <!-- 审核详情 -->
    <div class="rela-box" v-show="tabIndex == 2">
      <div class="in-item">
        <div class="key">
          审核状态
          <span
            class="value ml30"
            :class="{
              'value-rejected': status == '2',
              'value-resolve': status == '1',
              'value-examine':
                status == '0' ||
                status == '4' ||
                status == '5' ||
                status == '3',
            }"
            >{{
              status == '0'
                ? '待审核'
                : status == '1'
                ? '审核通过'
                : status == '2'
                ? '审核不通过'
                : status == '3'
                ? '待提交'
                : status == '4'
                ? '初审通过'
                : '复审通过'
            }}</span
          >
        </div>
        <div class="value">
          <ul class="process">
            <li
              class="process-item"
              v-for="item in checkOperateLogArr"
              :key="item.id"
            >
              <span class="operate">{{ item.operateLog }}</span>
              <span
                :class="[
                  item.stateAfter == 1
                    ? 'exa1'
                    : item.stateAfter == 2
                    ? 'exa2'
                    : 'exa3',
                ]"
              >
                {{ item.stateAfterText }}
              </span>
              <div class="comment" v-if="item.userComment">
                审核意见：{{ item.userComment }}
              </div>
              <div class="download-btn" v-if="item.attachmentUrl">
                <span>相关附件：{{ item.fileName }}</span>
                <a
                  :href="rootUrl + item.attachmentUrl"
                  :download="rootUrl + item.attachmentUrl"
                  target="_blank"
                >
                  下载</a
                >
              </div>
            </li>
          </ul>
        </div>
        <!-- 退回修改按钮 -->
      </div>
      <div class="back-modify" v-if="status == 2" @click="backModify()">
        退回修改
      </div>
    </div>
  </a-modal>
</template>

<script>
import course from '../../api/course'

import institution from '../../api/institution'

export default {
  name: 'courseDetailModal',
  data() {
    return {
      visible: false,
      confirmLoading: false,
      course: {},
      checkOperateLogArr: [], // 审核记录
      rootUrl: '', // 基地址
      userInfo: null,
      tabIndex: 1, // tab切换
      isNoPass: false, //展示审核不通过输入框
      status: '', // 审核状态
      failReason: '', //审核失败原因
      institutionSetting: {},
      roleId: null,
    }
  },
  methods: {
    //初始化，显示
    init(type, detail) {
      let _this = this
      console.log(type, detail,'11111111111')
      if (type == 'tuijian') {
        _this.getdetails(detail.id)
      }
      this.getHostUrl()
      this.getCheckOperateLog(detail.courseId)
      this.visible = true
      this.course = detail
      this.isNoPass = false
      this.failReason = ''
      this.course.intro = this.course.intro
        ? this.course.intro.replace(/<img/g, '<img style="width: 100% "')
        : ''
    },

    //隐藏
    handleCancel() {
      this.visible = false
      this.$emit('closeForm')
    },
    // 获取机构设置
    getInstitutionSetting() {
      institution.getInstitutionSetting().then((res) => {
        this.institutionSetting = res.data
      })
    },
    // 获取详情
    getdetails(id) {
      course.getCourseById(id).then((res) => {
        // console.log(res)
        this.course = res.data
      })
    },
    // 获取审核详情
    getCheckOperateLog(id) {
      course.getCheckOperateLog(id).then((res) => {
        // console.log('获取审核详情-----', res)
        res.data.checkOperateLogDos.forEach((v) => {
          if (v.attachmentUrl) {
            let fileArr = v.attachmentUrl.split("_");
            v.attachmentUrl = encodeURIComponent(v.attachmentUrl);
            if (fileArr.length > 2) {
              let temp = "";
              fileArr.shift();
              temp = fileArr.join("_");
              v.fileName = temp;
            } else if (fileArr.length == 2) {
              v.fileName = fileArr[1];
            }

            if (v.fileName == undefined) {
              v.fileName = "无附件名";
            }
          }
        });
        this.status = res.data.status
        this.checkOperateLogArr = res.data.checkOperateLogDos
      }).catch(err=>{
        this.status = 3
        this.checkOperateLogArr = []
      })
    },
    //审核课程 checkStatus 1-审核通过，2-审核不通过
    checkCourse(status) {
      let req = {
        status: status,
        failReason: this.failReason,
      }
      course.check(this.course.id, req).then((res) => {
        this.visible = false
        this.$message.success('审核成功')
        this.course = res.data
        //修改状态
        this.$emit('updateCourse', res.data)
      })
    },
    getHostUrl() {
      const locationHost = location.host
      this.rootUrl = globalConfig.rootUrl + '/api/pcWeb/aliyun/getFile?url='
    },
    // 退回修改
    backModify() {
      this.$emit('back-modify', this.course)
    },
  },

  created() {
    this.$store.dispatch('getUserInfo').then((res) => {
      this.userInfo = res
      this.roleId = res.roleId
      if(res.roleId == 4 || res.roleId == 6){
        this.getInstitutionSetting()
      }
    })
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.ml30 {
  margin-left: 30px;
}
.course-header {
  height: 39px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  margin-bottom: 24px;
  span {
    height: 100%;
    display: inline-block;
    font-size: 16px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    margin-right: 36px;
    cursor: pointer;
  }
  .item-active {
    color: #3198ff;
    border-bottom: 2px solid #3198ff;
  }
}
.course-info {
  text-align: left;
  height: calc(100vh - 280px);
  overflow-y: auto;
  overflow-x: hidden;
  li {
    font-size: 16px;
    line-height: 40px;
    padding: 6px 0px;
    .key {
      display: inline-block;
      font-weight: 600px;
      color: $normal-color-light;
      width: 170px;
      text-align: right;
    }
    .value {
      vertical-align: top;
      color: $normal-color-dark;
      padding-left: 6px;
      display: inline-block;
      padding-right: 16px;
      text-align: left;
      width: calc(100% - 170px);
      .item {
        border-bottom: 1px solid $border-color;
      }
      img {
        width: 100px;
        height: 100px;
        vertical-align: top;
      }
    }
    .list {
      margin-left: 100px;
    }
    .oper {
      color: $primary-color-dark;
      cursor: pointer;
    }
    .intro {
      width: 100%;
      padding: 0px 20px 0px 50px;
      display: inline-block;
      color: $normal-color-dark;
    }
  }
  .update-oper {
    text-align: center;
  }
}
.course-check {
  margin-top: 16px;
  text-align: center;
}
.check-confirm {
  margin-top: 16px;
  textarea {
    width: 300px;
    margin-left: 376px;
    vertical-align: middle;
    margin-right: 8px;
  }
}
.file-list {
  display: inline-block;
  width: calc(100% - 100px);
  vertical-align: top;
}
.in-item {
  height: calc(100vh - 280px);
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 20px;
  padding-bottom: 10px;
  > .key {
    color: rgba(0, 0, 0, 0.85);
    font-size: 20px;
    font-weight: 600;
  }
  > .value {
    font-size: 14px;
    color: #606266;
    margin-top: 19px;
    margin-left: 74px;
  }

  .process {
    width: 100%;
    height: 100%;
    overflow: auto;
    margin-left: 52px;
    margin-top: 19px;
    &-item {
      margin-bottom: 10px;

      .operate {
        color: #c0c4cc;
        margin-left: 26px;
      }
      // 审核意见
      .comment {
        color: #333;
        margin-left: 30px;
      }
      // 下载附件
      .download-btn {
        color: #333;
        margin-left: 30px;
        a {
          margin-left: 20px;
        }
      }
    }
    li:before {
      content: '';
      width: 4px;
      height: 4px;
      display: inline-block;
      border-radius: 50%;
      background: #bdbdbd;
      vertical-align: middle;
    }
  }

  // 审核通过颜色
  .exa1 {
    color: #19ca3c;
  }
  // 审核驳回颜色
  .exa2 {
    color: #f95050;
  }
  // 初审、复审颜色
  .exa3 {
    color: #ffa91f;
  }
}
// 相对父盒子定位
.rela-box {
  position: relative;
  // 退回修改按钮
  .back-modify {
    width: 108px;
    height: 32px;
    font-size: 14px;
    color: #fff;
    border-radius: 4px;
    line-height: 32px;
    text-align: center;
    background: #3198ff;
    position: absolute;
    bottom: 0;
    right: 18px;
    cursor: pointer;
  }
}

.value-resolve {
  color: #37c847 !important;
}
.value-rejected {
  color: #f54d15 !important;
}
.value-examine {
  color: #ffa91f !important;
}
</style>
